(() => {
  const swiperSelector = '#cart-upsell-recommendations .swiper-upsell';

  const initSwiper = (el) => {
    if (!window.Swiper || el.classList.contains('swiper-initialized')) return;

    const container = el.closest('#cart-upsell-recommendations') || document;
    const nextBtn = container.querySelector('.swiper-button-next');
    const prevBtn = container.querySelector('.swiper-button-prev');

    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 16,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      observer: true,
      observeParents: true,
    });
  };

  const scan = () => {
    document.querySelectorAll(swiperSelector).forEach(initSwiper);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  const observer = new MutationObserver(() => {
    scan();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Re-init after cart updates (e.g., drawer re-render)
  document.addEventListener('cart:update', () => {
    // Delay to allow DOM replacement to finish
    setTimeout(scan, 0);
  });
})();
